import "@justworkshr/milo-font/src/index.css";
import "@justworkshr/milo-design-tokens/build/css/tokens.css";
import "@justworkshr/milo-base-css/src/index.css";

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app/app";
import { initializeDataDog, initializeHeap } from "app/analytics";
import { preloadUspSdk } from "lib/usp/api";

import { handleReferrer } from "lib/referrerApp/referrerApp";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
initializeHeap();
initializeDataDog();
preloadUspSdk();
handleReferrer(window.location.search);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
